const bairros_centros = {
    
        "abolição": {
            "lat": -22.8853849,
            "lng": -43.2994958
        },
        "acari": {
            "lat": -22.8255154,
            "lng": -43.3445447
        },
        "alto da boa vista": {
            "lat": -22.9726463,
            "lng": -43.2841586
        },
        "anchieta": {
            "lat": -22.8208388,
            "lng": -43.396871
        },
        "andaraí": {
            "lat": -22.922329,
            "lng": -43.2477454
        },
        "anil": {
            "lat": -22.9530818,
            "lng": -43.3380822
        },
        "araújo de cosmos": {
            "lat": -22.9124113,
            "lng": -43.6103848
        },
        "baia de guanabara": {
            "lat": -22.8115667,
            "lng": -43.1544605
        },
        "bancários": {
            "lat": -22.7910971,
            "lng": -43.18085629999999
        },
        "bangu": {
            "lat": -22.8741734,
            "lng": -43.46860059999999
        },
        "barra da tijuca": {
            "lat": -23.0040194,
            "lng": -43.3661069
        },
        "barra de guaratiba": {
            "lat": -23.0632528,
            "lng": -43.5657496
        },
        "barros filho": {
            "lat": -22.8361571,
            "lng": -43.3635172
        },
        "benfica": {
            "lat": -22.8942309,
            "lng": -43.2391298
        },
        "bento ribeiro": {
            "lat": -22.8667937,
            "lng": -43.3632866
        },
        "bonsucesso": {
            "lat": -22.8625775,
            "lng": -43.254037
        },
        "botafogo": {
            "lat": -22.9510978,
            "lng": -43.1807461
        },
        "brás de pina": {
            "lat": -22.8344389,
            "lng": -43.3027813
        },
        "cachambi": {
            "lat": -22.8900676,
            "lng": -43.2737188
        },
        "cacuia": {
            "lat": -22.8165258,
            "lng": -43.186651
        },
        "caju": {
            "lat": -22.8807991,
            "lng": -43.2278482
        },
        "camorim": {
            "lat": -22.9693529,
            "lng": -43.4274676
        },
        "campinho": {
            "lat": -22.8834352,
            "lng": -43.3538259
        },
        "campo grande": {
            "lat": -22.907662,
            "lng": -43.5659086
        },
        "campo dos afonsos": {
            "lat": -22.8788308,
            "lng": -43.379909
        },
        "cascadura": {
            "lat": -22.8821983,
            "lng": -43.3247002
        },
        "catete": {
            "lat": -22.9268338,
            "lng": -43.1793449
        },
        "catumbi": {
            "lat": -22.9162577,
            "lng": -43.1954265
        },
        "cavalcanti": {
            "lat": -22.8707457,
            "lng": -43.3129764
        },
        "centro": {
            "lat": -22.9012249,
            "lng": -43.1791747
        },
        "cidade nova": {
            "lat": -22.909233,
            "lng": -43.2003317
        },
        "cidade universitária": {
            "lat": -22.8628536,
            "lng": -43.2263053
        },
        "cidade de deus": {
            "lat": -22.9465337,
            "lng": -43.3697151
        },
        "cocotá": {
            "lat": -22.8030483,
            "lng": -43.18151659999999
        },
        "coelho neto": {
            "lat": -22.8316594,
            "lng": -43.3479611
        },
        "colégio": {
            "lat": -22.8403348,
            "lng": -43.3387226
        },
        "copacabana": {
            "lat": -22.9692808,
            "lng": -43.1867944
        },
        "cordovil": {
            "lat": -22.8239006,
            "lng": -43.3010908
        },
        "cosme velho": {
            "lat": -22.9402577,
            "lng": -43.1998014
        },
        "cosmos": {
            "lat": -22.9119227,
            "lng": -43.614537
        },
        "costa barros": {
            "lat": -22.8246094,
            "lng": -43.3726806
        },
        "curicica": {
            "lat": -22.9500004,
            "lng": -43.3832724
        },
        "curral falso": {
            "lat": -22.9197453,
            "lng": -43.6564221
        },
        "del castilho": {
            "lat": -22.8812693,
            "lng": -43.2762917
        },
        "dendê": {
            "lat": -22.8053883,
            "lng": -43.1868232
        },
        "deodoro": {
            "lat": -22.8559796,
            "lng": -43.38606499999999
        },
        "dumas": {
            "lat": -22.9360599,
            "lng": -43.6962786
        },
        "encantado": {
            "lat": -22.8959763,
            "lng": -43.3021889
        },
        "engenheiro leal": {
            "lat": -22.8748201,
            "lng": -43.3255452
        },
        "engenho novo": {
            "lat": -22.9019487,
            "lng": -43.2690737
        },
        "engenho da rainha": {
            "lat": -22.865215,
            "lng": -43.2970248
        },
        "engenho de dentro": {
            "lat": -22.8939154,
            "lng": -43.2954699
        },
        "estácio": {
            "lat": -22.9175914,
            "lng": -43.2048213
        },
        "flamengo": {
            "lat": -22.9332358,
            "lng": -43.1746947
        },
        "freguesia (ilha)": {
            "lat": -22.789937,
            "lng": -43.1758344
        },
        "freguesia (jacarepaguá)": {
            "lat": -22.9398594,
            "lng": -43.3437092
        },
        "galeão": {
            "lat": -22.8118769,
            "lng": -43.22744
        },
        "gamboa": {
            "lat": -22.8969588,
            "lng": -43.1908313
        },
        "gardênia azul": {
            "lat": -22.9582037,
            "lng": -43.3529536
        },
        "glória": {
            "lat": -22.9204249,
            "lng": -43.1744643
        },
        "grajaú": {
            "lat": -22.923666,
            "lng": -43.2583192
        },
        "grumari": {
            "lat": -23.0493444,
            "lng": -43.5337287
        },
        "guadalupe": {
            "lat": -22.8401032,
            "lng": -43.3781182
        },
        "guarabu": {
            "lat": -22.8283497,
            "lng": -43.38647050000001
        },
        "guaratiba": {
            "lat": -22.9611952,
            "lng": -43.6120746
        },
        "gávea": {
            "lat": -22.9758487,
            "lng": -43.2283465
        },
        "honório gurgel": {
            "lat": -22.8453522,
            "lng": -43.355824
        },
        "humaitá": {
            "lat": -22.9566274,
            "lng": -43.1985844
        },
        "inhaúma": {
            "lat": -22.8714919,
            "lng": -43.282418
        },
        "inhoaíba": {
            "lat": -22.9040473,
            "lng": -43.5959933
        },
        "ipanema": {
            "lat": -22.9845996,
            "lng": -43.1986199
        },
        "irajá": {
            "lat": -22.844329,
            "lng": -43.3231669
        },
        "itacolomi": {
            "lat": -22.8102227,
            "lng": -43.2346174
        },
        "itanhangá": {
            "lat": -22.9870599,
            "lng": -43.3076592
        },
        "jacarepaguá": {
            "lat": -22.9681893,
            "lng": -43.3909014
        },
        "jacaré": {
            "lat": -22.8920532,
            "lng": -43.2558442
        },
        "jardim américa": {
            "lat": -22.8114452,
            "lng": -43.3208041
        },
        "jardim botí¢nico": {
            "lat": -22.9068467,
            "lng": -43.1728965
        },
        "jardim carioca": {
            "lat": -22.8057705,
            "lng": -43.1932173
        },
        "jardim guanabara": {
            "lat": -22.8079788,
            "lng": -43.2070081
        },
        "jardim sulacap": {
            "lat": -22.8882267,
            "lng": -43.3943954
        },
        "joá": {
            "lat": -23.0094686,
            "lng": -43.2906092
        },
        "lagoa": {
            "lat": -22.9618197,
            "lng": -43.2030773
        },
        "laranjeiras": {
            "lat": -22.9332627,
            "lng": -43.1850071
        },
        "leblon": {
            "lat": -22.9842698,
            "lng": -43.223168
        },
        "leme": {
            "lat": -22.9616546,
            "lng": -43.1654625
        },
        "lins de vasconcelos": {
            "lat": -22.9128722,
            "lng": -43.2845323
        },
        "loteamento madean": {
            "lat": -22.9394156,
            "lng": -43.6812988
        },
        "madureira": {
            "lat": -22.8724517,
            "lng": -43.3363996
        },
        "magalhães bastos": {
            "lat": -22.8711722,
            "lng": -43.4145531
        },
        "mangueira": {
            "lat": -22.9025508,
            "lng": -43.2370745
        },
        "manguinhos": {
            "lat": -22.8825193,
            "lng": -43.2442626
        },
        "maracanã": {
            "lat": -22.9123598,
            "lng": -43.2265474
        },
        "marechal hermes": {
            "lat": -22.8599085,
            "lng": -43.3697557
        },
        "maria da graça": {
            "lat": -22.8851846,
            "lng": -43.26747
        },
        "maré": {
            "lat": -22.8518205,
            "lng": -43.2431352
        },
        "méier": {
            "lat": -22.9020826,
            "lng": -43.2803793
        },
        "nossa senhora das graças": {
            "lat": -22.8618375,
            "lng": -43.4892285
        },
        "olaria": {
            "lat": -22.8487261,
            "lng": -43.2666279
        },
        "oswaldo cruz": {
            "lat": -22.8750247,
            "lng": -43.3511611
        },
        "paciência": {
            "lat": -22.8837995,
            "lng": -43.6389605
        },
        "padre miguel": {
            "lat": -22.8780905,
            "lng": -43.4482789
        },
        "paquetá": {
            "lat": -22.7624224,
            "lng": -43.1082103
        },
        "parada de lucas": {
            "lat": -22.8185145,
            "lng": -43.3028834
        },
        "parque anchieta": {
            "lat": -22.8335606,
            "lng": -43.4019667
        },
        "pavuna": {
            "lat": -22.8112771,
            "lng": -43.36253320000001
        },
        "pechincha": {
            "lat": -22.928869,
            "lng": -43.3542295
        },
        "pedra de guaratiba": {
            "lat": -23.0019127,
            "lng": -43.6380866
        },
        "penha": {
            "lat": -22.8361906,
            "lng": -43.2759767
        },
        "penha circular": {
            "lat": -22.8392917,
            "lng": -43.2913678
        },
        "piedade": {
            "lat": -22.8963,
            "lng": -43.3126497
        },
        "pilares": {
            "lat": -22.8814212,
            "lng": -43.2934238
        },
        "pitangueiras": {
            "lat": -22.8156502,
            "lng": -43.1785558
        },
        "portuguesa": {
            "lat": -22.7987466,
            "lng": -43.2043949
        },
        "praia da bandeira": {
            "lat": -22.8098498,
            "lng": -43.1793597
        },
        "praça seca": {
            "lat": -22.900353,
            "lng": -43.3540577
        },
        "praça da bandeira": {
            "lat": -22.9122663,
            "lng": -43.2133348
        },
        "quintino bocaiúva": {
            "lat": -22.8874122,
            "lng": -43.3203933
        },
        "ramos": {
            "lat": -22.8502757,
            "lng": -43.2565495
        },
        "realengo": {
            "lat": -22.8786476,
            "lng": -43.4284708
        },
        "recreio dos bandeirantes": {
            "lat": -23.0178705,
            "lng": -43.4647479
        },
        "riachuelo": {
            "lat": -22.8998361,
            "lng": -43.25506730000001
        },
        "ribeira": {
            "lat": -22.823029,
            "lng": -43.1713927
        },
        "ricardo de albuquerque": {
            "lat": -22.8358471,
            "lng": -43.39210430000001
        },
        "rio comprido": {
            "lat": -22.9252121,
            "lng": -43.2053745
        },
        "rocha": {
            "lat": -22.8979553,
            "lng": -43.2504219
        },
        "rocha miranda": {
            "lat": -22.8519449,
            "lng": -43.34677
        },
        "rocinha": {
            "lat": -22.987941,
            "lng": -43.2480087
        },
        "sampaio": {
            "lat": -22.902136,
            "lng": -43.2613203
        },
        "santa cruz": {
            "lat": -22.9208226,
            "lng": -43.6809034
        },
        "santa teresa": {
            "lat": -22.9206375,
            "lng": -43.1896095
        },
        "santo cristo": {
            "lat": -22.8996529,
            "lng": -43.2014142
        },
        "santíssimo": {
            "lat": -22.8759202,
            "lng": -43.5262687
        },
        "saúde": {
            "lat": -22.8974908,
            "lng": -43.1851777
        },
        "senador camará": {
            "lat": -22.8727268,
            "lng": -43.4949441
        },
        "senador vasconcelos": {
            "lat": -22.8941762,
            "lng": -43.5360193
        },
        "sepetiba": {
            "lat": -22.9693596,
            "lng": -43.6966942
        },
        "são conrado": {
            "lat": -22.9984744,
            "lng": -43.2694905
        },
        "são cristóvão": {
            "lat": -22.8996469,
            "lng": -43.2227
        },
        "são francisco xavier": {
            "lat": -22.9044482,
            "lng": -43.2431641
        },
        "tanque": {
            "lat": -22.9161954,
            "lng": -43.3551228
        },
        "taquara": {
            "lat": -22.9229954,
            "lng": -43.3742313
        },
        "tauá": {
            "lat": -22.8005228,
            "lng": -43.1868831
        },
        "tijuca": {
            "lat": -22.9324433,
            "lng": -43.2411073
        },
        "todos os santos": {
            "lat": -22.8928489,
            "lng": -43.2847179
        },
        "tomás coelho": {
            "lat": -22.865079,
            "lng": -43.3090791
        },
        "tubiacanga": {
            "lat": -22.7864191,
            "lng": -43.2273605
        },
        "turiaçu": {
            "lat": -22.8613813,
            "lng": -43.3438018
        },
        "urca": {
            "lat": -22.9545667,
            "lng": -43.1670542
        },
        "vargem grande": {
            "lat": -22.9762943,
            "lng": -43.4941932
        },
        "vargem pequena": {
            "lat": -22.9826458,
            "lng": -43.4630981
        },
        "vaz lobo": {
            "lat": -22.8568819,
            "lng": -43.3292075
        },
        "vicente de carvalho": {
            "lat": -22.8557822,
            "lng": -43.3157393
        },
        "vidigal": {
            "lat": -22.99453,
            "lng": -43.23782509999999
        },
        "vigário geral": {
            "lat": -22.8086939,
            "lng": -43.3071081
        },
        "vila isabel": {
            "lat": -22.9165886,
            "lng": -43.2502461
        },
        "vila cosmos": {
            "lat": -22.8536931,
            "lng": -43.3037194
        },
        "vila militar": {
            "lat": -22.86386,
            "lng": -43.39768979999999
        },
        "vila valqueire": {
            "lat": -22.8811664,
            "lng": -43.3706007
        },
        "vila da penha": {
            "lat": -22.844146,
            "lng": -43.3094211
        },
        "vista alegre": {
            "lat": -22.8288673,
            "lng": -43.3169088
        },
        "zumbi": {
            "lat": -22.8216051,
            "lng": -43.1760971
        },
        "água santa": {
            "lat": -22.9051657,
            "lng": -43.3071354
        }
    }
export default bairros_centros;